import { render, staticRenderFns } from "./TruckRouting.vue?vue&type=template&id=ca544604"
import script from "./TruckRouting.vue?vue&type=script&lang=ts"
export * from "./TruckRouting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports